import { watchListsFeatureEntityEffects } from './entities';


export const watchListsFeatureEffects = [...watchListsFeatureEntityEffects];
